import React from 'react';
import LandingPanel from '../../landingPagePanel/landingPagePanel';
import {ToastContainer} from "react-toastify";
import LandingSidebar from '../../landingSidebar/landingSidebar';

const akkaSidebarLinks = [
    {label: 'Overview', to: '/distributed-computing/akka'},
];

const akkaConcepts = [
    {id: 1, title: 'What is Akka?',
        content: 'An introduction to Akka and the actor model.',
        slug: 'what-is-akka',
        image: '/images/distributed/akka-landing/what-is-akka.svg',
        enabled: false,
        sourceLinks: []},
    {id: 2, title: 'Concepts in Akka',
        content: 'The concepts behind Akka',
        slug: 'akka-concepts',
        image: '/images/distributed/distributed-framework-landing/concepts.svg',
        enabled: false,
        sourceLinks: []},
    {id: 3, title: 'Actors in Akka',
        content: 'How Akka implements the actor model',
        slug: 'akka-actors',
        image: '/images/distributed/akka-landing/akka-actors.svg',
        enabled: false,
        sourceLinks: []},
    {id: 4, title: 'Actor Systems in Akka',
        content: 'The runtime that creates and hosts actors',
        slug: 'akka-actor-systems',
        image: '/images/distributed/akka-landing/akka-actor-systems.svg',
        enabled: false,
        sourceLinks: []},
    {id: 5, title: 'State in Akka',
        content: 'How Akka handles state',
        slug: 'akka-state',
        image: '/images/distributed/distributed-framework-landing/state.svg',
        enabled: false,
        sourceLinks: []},
    {id: 6, title: 'Persistence in Akka',
        content: 'Event sourcing with Akka Persistence',
        slug: 'akka-persistence',
        image: '/images/distributed/akka-landing/akka-persistence.svg',
        enabled: false,
        sourceLinks: []},
    {id: 7, title: 'Dispatchers in Akka',
        content: 'How Akka schedules actors onto threads',
        slug: 'akka-dispatchers',
        image: '/images/distributed/akka-landing/akka-dispatchers.svg',
        enabled: false,
        sourceLinks: []},
    {id: 8, title: 'Clustering in Akka',
        content: 'Joining multiple actor systems into one cluster',
        slug: 'akka-clustering',
        image: '/images/distributed/akka-landing/akka-clustering.svg',
        enabled: false,
        sourceLinks: []},
    {id: 9, title: 'Akka Management',
        content: 'Operating and monitoring a running cluster',
        slug: 'akka-management',
        image: '/images/distributed/akka-landing/akka-management.svg',
        enabled: false,
        sourceLinks: []},
    {id: 10, title: 'Akka Streams',
        content: 'Stream processing with Akka',
        slug: 'akka-streams',
        image: '/images/distributed/akka-landing/akka-streams.svg',
        enabled: false,
        sourceLinks: []},
    {id: 11, title: 'Observability in Akka',
        content: 'Akka metrics with Prometheus and Grafana',
        slug: 'akka-observability',
        image: '/images/distributed/akka-landing/akka-observability.svg',
        enabled: false,
        sourceLinks: []},
    {id: 12, title: 'Unit Testing in Akka',
        content: 'How to unit test actors with Akka TestKit',
        slug: 'akka-unit-testing',
        image: '/images/distributed/akka-landing/akka-unit-testing.svg',
        enabled: false,
        sourceLinks: []}
];

const akkaActorDetails = [
    {id: 1, title: 'Actor Identity',
        content: 'What an ActorRef and ActorPath are',
        slug: 'akka-actor-identity',
        image: '/images/distributed/akka-landing/akka-actor-identity.svg',
        enabled: false,
        sourceLinks: []},
    {id: 2, title: 'Actor Lifecycle',
        content: 'The lifecycle of an actor in Akka',
        slug: 'akka-actor-lifecycle',
        image: '/images/distributed/akka-landing/akka-actor-lifecycle.svg',
        enabled: false,
        sourceLinks: []},
    {id: 3, title: 'Supervision and Hierarchy',
        content: 'How parent actors supervise their children',
        slug: 'akka-supervision',
        image: '/images/distributed/akka-landing/akka-supervision.svg',
        enabled: false,
        sourceLinks: []},
    {id: 4, title: 'Actor State',
        content: 'How an individual actor carries its own state',
        slug: 'akka-actor-state',
        image: '/images/distributed/akka-landing/akka-actor-state.svg',
        enabled: false,
        sourceLinks: []},
    {id: 5, title: 'Routers',
        content: 'Distributing work across a pool of actors',
        slug: 'akka-routers',
        image: '/images/distributed/akka-landing/akka-routers.svg',
        enabled: false,
        sourceLinks: []},
    {id: 6, title: 'Remote Actors',
        content: 'Actors that communicate across the network',
        slug: 'akka-remote-actors',
        image: '/images/distributed/akka-landing/akka-remote-actors.svg',
        enabled: false,
        sourceLinks: []},
    {id: 7, title: 'Message Stashing',
        content: 'Temporarily deferring messages for later',
        slug: 'akka-message-stashing',
        image: '/images/distributed/akka-landing/akka-message-stashing.svg',
        enabled: false,
        sourceLinks: []}
];

const akkaSimpleExamples = [
    {id: 1, title: 'Hello Actor',
        content: 'The classic first actor: receiving and logging a message',
        slug: 'akka-hello-actor',
        image: '/images/distributed/akka-landing/hello-actor.svg',
        enabled: false,
        sourceLinks: []},
    {id: 2, title: 'Ping Pong Actors',
        content: 'Two actors exchanging messages back and forth',
        slug: 'akka-ping-pong',
        image: '/images/distributed/akka-landing/ping-pong-actors.svg',
        enabled: false,
        sourceLinks: []},
    {id: 3, title: 'Stateful Counter Actor',
        content: 'An actor that maintains its own internal count',
        slug: 'akka-counter-actor',
        image: '/images/distributed/akka-landing/counter-actor.svg',
        enabled: false,
        sourceLinks: []},
    {id: 4, title: 'Supervision and Restart',
        content: 'A parent actor restarting a child after it fails',
        slug: 'akka-supervision-restart',
        image: '/images/distributed/akka-landing/supervision-restart.svg',
        enabled: false,
        sourceLinks: []}
];

const akkaAdvancedExamples = [
    {id: 1, title: 'Distributed Chat Server',
        content: 'Actors modelling chat rooms and users spread across a cluster',
        slug: 'akka-distributed-chat-server',
        image: '/images/distributed/akka-landing/distributed-chat-server.svg',
        enabled: false,
        sourceLinks: []},
    {id: 2, title: 'IoT Device Coordinator',
        content: 'A hub actor coordinating state for thousands of IoT devices',
        slug: 'akka-iot-device-coordinator',
        image: '/images/distributed/akka-landing/iot-device-coordinator.svg',
        enabled: false,
        sourceLinks: []}
];

const AkkaLanding = () => {
    return (
        <React.Fragment>
            <ToastContainer
                autoClose={5000}
                hideProgressBar={true}
            />
            <div className="relative space-y-4 flex flex-col md:grid md:space-y-0 w-full md:grid-cols-12 2xl:grid-cols-12 md:flex-1 md:grid-rows-full">
                <LandingSidebar title="Akka" links={akkaSidebarLinks}/>
                <section className="pt-2 border-gray-200 md:col-span-10 lg:col-span-10 2xl:col-span-10 pb-24">
            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                    <div className="lg:pr-12 lg:place-self-top">
                        <div className="flex flex-col ">
                            <svg className="text-red-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <div className="h-2" />
                            <div className="flex  rounded-lg">
                                <div>
                                    <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Akka Concepts
                                    </h2></div>
                            </div>
                            <div className="h-6" />
                            <p className="leading-snug text-gray-500">Some of the concepts and functionality underpinning Akka
                            </p>
                            <div className="h-6" />
                        </div>
                    </div>
                    <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                        {akkaConcepts.map((data) => (
                            <LandingPanel key={data.id} title={data.title} imageSource={data.image} to={"/distributed-computing/akka/concepts/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                        ))}
                    </div>
                </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                    <div className="lg:pr-12 lg:place-self-top">
                        <div className="flex flex-col ">
                            <svg className="text-blue-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <div className="h-2"></div>
                            <div className="flex  rounded-lg">
                                <div>
                                    <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Actor Features
                                    </h2></div>
                            </div>
                            <div className="h-6"></div>
                            <p className="leading-snug text-gray-500">Some features we find in Actors
                            </p>
                            <div className="h-6"></div>
                        </div>
                    </div>
                    <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                        {akkaActorDetails.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/distributed-computing/akka/actors/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                        ))}
                    </div>
                </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                    <div className="lg:pr-12 lg:place-self-top">
                        <div className="flex flex-col ">
                            <svg className="text-green-400 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <div className="h-2"></div>
                            <div className="flex  rounded-lg">
                                <div>
                                    <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Simple Examples
                                    </h2></div>
                            </div>
                            <div className="h-6"></div>
                            <p className="leading-snug text-gray-500">Some simple examples with Akka
                            </p>
                            <div className="h-6"></div>
                        </div>
                    </div>
                    <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                        {akkaSimpleExamples.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/distributed-computing/akka/examples/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                        ))}
                    </div>
                </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900 py-16 md:py-16">
                <div className="w-full px-4 grid lg:grid-cols-3 gap-x-6 gap-y-12 lg:gap-y-0">
                    <div className="lg:pr-12 lg:place-self-top">
                        <div className="flex flex-col ">
                            <svg className="text-fuchsia-800 text-2xl" width="1.5em" height="1.5em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 13V21L5 16V8L12 3L19 8L12 13Z" fill="currentColor" opacity="0.5"/>
                                <path d="M12 21V13M12 21L5.83752 16.5982C5.42695 16.305 5.22166 16.1583 5.11083 15.943C5 15.7276 5 15.4753 5 14.9708V8M12 21L18.1625 16.5982C18.573 16.305 18.7783 16.1583 18.8892 15.943C19 15.7276 19 15.4753 19 14.9708V8M12 13L5 8M12 13L19 8M5 8L10.8375 3.83034C11.3989 3.42938 11.6795 3.2289 12 3.2289C12.3205 3.2289 12.6011 3.42938 13.1625 3.83034L19 8" stroke="#222222"  strokeWidth="1.2" opacity="0.5"/>
                            </svg>
                            <div className="h-2"></div>
                            <div className="flex  rounded-lg">
                                <div>
                                    <h2 className="text-2xl font-semibold
											leading-tight text-gray-800 false">Advanced Examples
                                    </h2></div>
                            </div>
                            <div className="h-6"></div>
                            <p className="leading-snug text-gray-500">Some more in depth examples
                            </p>
                            <div className="h-6"></div>
                        </div>
                    </div>
                    <div className="lg:col-span-2 grid lg:grid-cols-2 gap-4">
                        {akkaAdvancedExamples.map((data) => (
                            <LandingPanel key={data.id}  title={data.title} imageSource={data.image} to={"/distributed-computing/akka/examples/" + data.slug} strapLine={data.content} enabled={data.enabled}  />
                        ))}
                    </div>
                </div>
            </div>
                </section>
            </div>

        </React.Fragment>
    )
};

export default React.memo(AkkaLanding);
